type OrderComponentLike = {
  component_type?: "gift" | "set_item";
};

export function groupOrderComponents<T extends OrderComponentLike>(components: T[] = []) {
  return {
    setItems: components.filter((component) => component.component_type === "set_item"),
    gifts: components.filter((component) => component.component_type !== "set_item"),
  };
}
